import { useNoticesContext } from '../components/notices/NoticesContext'

export default function useValidations() {
    const { addNotices, clearNotices, scrollToNotices } = useNoticesContext()

    function showValidations(validations) {
        if (validations == null) {
            return
        }

        if (validations.length === 0) {
            clearNotices()
            return
        }

        if (validations.length > 0) {
            const notices = validations.map((validation) => ({
                type: validation.type,
                code: validation.code,
                params: validation.params,
            }))
            addNotices({ notices, clear: true })
        }
    }

    function clearValidations() {
        clearNotices()
    }

    return {
        showValidations,
        clearValidations,
        scrollToNotices,
    }
}
